// Locale можно импортировать из frame или других модулей,
// которые реэкспортируют frame, например product или studio
import * as React from "react";
import { WidgetFrame, Locale } from "../studio/index.js";
export { LocaleSample };

// Получаем локаль для компонента LocaleSample
const local = new Locale("LocaleSample");
// Если используется только local.message, то его можно сократить,
// если не хочется писать полное имя.
// const _ = new Locale("LocaleSample").message;
// И затем использовать как _("message"):
// console.debug(_("test1"));

/**
 * Пример локализации компонента.
 * @returns {JSX.Element} Элемент JSX.
 */
function LocaleSample() {
  let error1, error2, error3;
  try {
    // Пример исключения с локализованным сообщением
    throw local.error("error1");
  }
  catch (error) {
    error1 = error;
  }
  try {
    // Ошибка при использовании компонента.
    // Некорректное значение аргумента или состояния:
    // имя аргумента: error2,
    // неверное значение: null
    throw local.invalid("error2", null);
  }
  catch (error) {
    error2 = error;
  }
  try {
    // Пример проверки на внутренние ошибки компонента
    throw local.assert(false);
  }
  catch (error) {
    error3 = error;
  }
  return (
    <WidgetFrame icon="grid" title="Примеры локализованных сообщений">
      <dl>
        <dt>Локализованное число 1.23: </dt>
        <dd>{local.number(1.23)}</dd>

        <dt>Локализованная дата: </dt>
        <dd>{local.date(new Date)}</dd>

        <dt>Локализованное время: </dt>
        <dd>{local.time(new Date)}</dd>

        <dt>Локализованные дата/время: </dt>
        <dd>{local.timestamp(new Date)}</dd>

        <dt>Локализованное boolean: </dt>
        <dd>{local.boolean(true)}</dd>

        <dt>Локализованное сообщение test1: </dt>
        <dd>{local.message("test1")}</dd>

        <dt>Локализованное сообщение test2: </dt>
        <dd>{local.message("test2",
          {
            n: 1.23,
            time: new Date,
            str: "text_data"
          })}</dd>

        <dt>local.error(error1): </dt>
        <dd>{error1.message}</dd>

        <dt>local.invalid(error2, null): </dt>
        <dd>{error2.message}</dd>

        <dt>local.assert(false): </dt>
        <dd>{error3.message}</dd>
      </dl>
    </WidgetFrame>
  );
}

/**
 * Название примера для SampleRouter.
 * @private
 */
LocaleSample.title = "Локализация";
